<template>
  <div class="forgot-form">
    <transition name="fade" appear mode="out-in">

      <div v-if="!requestSent" :key="transitionKey">
        <h2 class="text-campton-bold">{{ $gettext('Forgot password') }}</h2>
        <p>
          {{ $gettext('Enter the email address associated with your account, and we\'ll send you a link to reset your password.') }}
        </p>
        <b-form @submit.prevent="requestPasswordReset" class="gk-clear-form">
          <b-form-group id="fieldset-login-email" :label="$gettext('Email')" label-for="input-login-email">
            <b-form-input 
              type="email"
              id="input-login-email"
              v-model="email"
              trim required
            />
          </b-form-group>
          <div style="display: flex; flex-direction:column; padding-top: 0.5rem; width: 100%;">
            <GekkoButton
              type="submit"
              :text="$gettext('Continue')"
              :loading="loading"
              variant="primary"
              class="login-btn text-campton-book mb-3 position-relative"
            />
            <GekkoButton
              :to="{ name: 'Login' }"
              :text="$gettext('Return to sign in')"
              variant="link"
              class="text-campton-book text-blue"
            />
          </div>
        </b-form>
      </div>
      <div v-if="requestSent && !retryRequest" :key="transitionKey">
        <h2 class="text-campton-bold">{{ $gettext('Check your email') }}</h2>
        <p v-html="$gettextInterpolate(checkYourMailText, { requestemail: email })" />
        <p>
          {{ $gettext('If you haven\'t received an email in 5 minutes, check your spam') }}, 
          <span @click="resend" class="text-blue cursor-pointer btn-link">{{ $gettext('resend') }}</span>, 
          {{ $gettext('or') }} <span @click="retry" class="text-blue cursor-pointer btn-link">{{ $gettext('try a different email address') }}</span>.
        </p>
      </div>
      <div v-if="requestSent && retryRequest" :key="transitionKey">
        <h2 class="text-campton-bold">{{ $gettext('Check your email') }}</h2>
        <p v-html="$gettextInterpolate(checkYourMailTextRetry, { requestemail: email })" />
        <p>
          {{ $gettext('Please check again. If you still haven\'t received an email') }}, <span @click="retry" class="text-blue cursor-pointer btn-link">{{ $gettext('try a different email address') }}</span>.
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from "vuex"

import GekkoButton from "@/components/GekkoButton"

export default {
  name: 'ForgotPasswordForm',
  components: {
    GekkoButton
  },
  props: {
    rememberEmail: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      email: '',
      requestSent: false,
      retryRequest: false,
      transitionKey: 0,
      loading: false
    }
  },
  computed: {
    checkYourMailText () {
      return this.$gettext('Thanks! If <span class=\'text-black\'>%{ requestemail }</span> matches an email address we have on file, then we\'ve sent you an email containing further instructions for resetting your password.') 
    },
    checkYourMailTextRetry () {
      return this.$gettext('We\'ve resent password reset instructions to <span class=\'text-black\'>%{ requestemail }</span> if it is an email address on file.')
    }
  },
  created () {
    if (this.rememberEmail && this.rememberEmail !== '') {
      this.email = this.rememberEmail
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions({ 
      getResetLink: "auth/getResetLink"
    }),
    requestPasswordReset () {
      this.loading = true
      this.transitionKey++

      this.getResetLink({
        'email': this.email,
      }).catch((err) => {
        console.log('ForgotPasswordForm.vue::requestPasswordReset() -> getResetLink ERROR', err)
      }).finally(() => {
        this.loading = false
        this.requestSent = true
      })
    },
    resend () {
      this.requestPasswordReset()
      this.transitionKey++
      this.retryRequest = true
    },
    retry () {
      this.transitionKey++
      this.retryRequest = false
      this.requestSent = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>